<div [formGroup]="form" class="form-group">
  <label>{{label}}</label>
  <textarea [rows]="rows" class="form-control" [ngClass]="getInvalidClass(controlName)" [placeholder]="label" [formControlName]="controlName"></textarea>
  <app-input-errors [element]="form.get(controlName)"></app-input-errors>
</div>
